module.exports = __webpack_public_path__ + "static/assets/2cbb7e6ca38b70b55d1e1eceb9a4ef1f.png";